export const getRelayStatePath = (url: string) => {
  const [, query = ''] = url.split('?');
  const relayState = new URLSearchParams(query).get('RelayState');

  if (!relayState) {
    return null;
  }

  const path = relayState.slice(relayState.lastIndexOf('#') + 1);

  if (!path.startsWith('/')) {
    return null;
  }

  const { origin } = window.location;
  const target = URL.parse(path, origin);

  return target?.origin === origin
    ? target.pathname + target.search + target.hash
    : null;
};
